var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auth-container',{on:{"signIn":function($event){return _vm.$emit('signIn', true)}}})}
var staticRenderFns = []

export { render, staticRenderFns }